<template>
  <WebsiteLayout>
    <div class="become-a-professional-home dashboard">
      <div class="div-block-89"></div>
      <h1 class="heading-3">
        Your next chapter, <span class="text-span-6">made possible</span> by
        Mentoring
      </h1>
      <div class="div-block-90" @click="getStarted">
        <div
          data-w-id="fda97848-08f7-4cf6-e4f7-17da6905e49c"
          class="button-17 w-button"
        >
          Get started
        </div>
      </div>
    </div>
    <BecomeAProfessionalModal
      v-if="professionalEnrol"
      :cancel="closeForm"
      :categories="categoryList"
      :category-object="categories"
      :levels="experienceLevels"
    />
    <ProfessionalSuccessModal
      v-if="professionalSuccess"
      :proceed="proceed"
      :cancel="closeSuccess"
    />
  </WebsiteLayout>
</template>

<script>
import WebsiteLayout from "@/components/layout/WebsiteLayout";
import BecomeAProfessionalModal from "@/components/modal/BecomeAProfessionalModal";
import ProfessionalSuccessModal from "@/components/modal/ProfessionalSuccessModal";
import RouterUtils from "@/utils/BaseUtils/RouterUtils";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import { mapState } from "vuex";
import ProfessionalRequest from "@/model/requests/ProfessionalRequest";

export default {
  name: "BecomeAProfessional",
  components: {
    ProfessionalSuccessModal,
    BecomeAProfessionalModal,
    WebsiteLayout
  },
  data() {
    return {
      start: false,
      success: true,
      bar: true,
      cross: false,
      readSubModel: ProfessionalRequest.readSubscriptionPlans
    };
  },
  computed: {
    categories() {
      return StoreUtils.rootGetters(
        StoreUtils.getters.professional.GET_CATEGORIES
      );
    },
    categoryList() {
      return Object.keys(this.categories);
    },
    experienceLevels() {
      return StoreUtils.rootGetters(
        StoreUtils.getters.professional.GET_EXPERIENCE_LEVELS
      );
    },
    ...mapState({
      professionalSuccess: state => state.professional.professionalSuccess,
      professionalEnrol: state => state.professional.profEnrol,
      customerToProfessionalId: state =>
        state.professional.customerToProfessionalId
    })
  },
  methods: {
    showNav() {
      this.cross = true;
      this.bar = false;
    },
    closeNav() {
      this.bar = true;
      this.cross = false;
    },
    getStarted() {
      // this.professionalEnrol = true;
      StoreUtils.commit(StoreUtils.mutations.professional.SET_PROF_ENROL, true);
    },
    closeForm() {
      StoreUtils.commit(
        StoreUtils.mutations.professional.SET_PROF_ENROL,
        false
      );
    },
    openSuccess() {
      this.start = false;
      this.success = true;
    },
    closeSuccess() {
      StoreUtils.commit(
        StoreUtils.mutations.professional.SET_PROFESSIONAL_SUCCESS,
        false
      );
    },
    proceed() {
      StoreUtils.commit(
        StoreUtils.mutations.professional.SET_PROFESSIONAL_SUCCESS,
        false
      );
      RouterUtils.changeRouteTo(RouterUtils.routes.auth.PROFESSIONAL_DASHBOARD);
      if (this.userInfo.professional.professionalId) {
        this.readSubModel.subscriptionPlanProfessionalId = this.userInfo.professional.professionalId;
      } else {
        this.readSubModel.subscriptionPlanProfessionalId = this.customerToProfessionalId;
      }
      // this.readSubModel.subscriptionPlanProfessionalId = this.professionalId;
      StoreUtils.dispatch(
        "professional/readSubscriptionPlans",
        this.readSubModel
      );
    }
  },
  mounted() {
    StoreUtils.dispatch(StoreUtils.actions.professional.FETCH_CATEGORIES);
    StoreUtils.dispatch(
      StoreUtils.actions.professional.FETCH_EXPERIENCE_LEVELS
    );
  }
};
</script>

<style scoped></style>
